<template>
  <div id="app" class="container-fluid">
    <!-- Lottie presentation code, depending on payment state -->
    <div class="main-content">
      <div class="menu-fixed menu-links">
        <img
          class="lone-star"
          src="@website-assets/img/lone-star.png"
          alt="Lone Star"
        /><a :href="accountLink" class="menu-link">{{
          accountText
        }}</a>
      </div>
      <!-- Header with title & video -->
      <header class="main-head">
        <div class="section-wrapper">
          <h1 class="header__logo">
            <img src="@website-assets/img/logo-stowy.png" alt="Stowy" />
          </h1>

          <h2 class="main-head__title">
            <Typed :options="typedOptions" :class="'kid-name'"> </Typed>
            &nbsp;{{ $t('home.head-title') }}
          </h2>

          <h3 class="main-head__descr">
            <span>{{ $i18n.t('home.head-desc-1') }}</span>
            {{ $i18n.t('home.head-desc-2') }}
          </h3>

          <p class="main-head__callout-btns">
            <a href="#stowy-plans" class="btn btn-primary btn-L">
              <span>{{ $i18n.t('global.i-subscribe') }}</span>
            </a>

            <a
              v-if="!canInstall"
              href="#bubble-points"
              class="btn btn-secondary btn-L"
              >{{ $i18n.t('global.i-discover') }}</a
            >

            <a
              v-if="canInstall"
              @click="installApp"
              class="btn btn-secondary btn-L"
              >{{ $i18n.t('global.try-stowy') }}</a
            >
          </p>

          <div class="starry">
            <img src="@website-assets/img/starry.png" alt />
          </div>
        </div>
      </header>

      <section class="menu">
        <img
          src="@website-assets/img/logo-stowy.png"
          alt="Stowy Logo"
          class="menu-logo"
        />

        <div class="menu-links menu-flex">
            <a href="#stowy-plans" class="menu-link subscribe-menu-btn"
            >Inscription</a
          >
          <div class="menu-fixed connect-menu-btn">
            <img
              class="lone-star"
              src="@website-assets/img/lone-star.png"
              alt="Lone Star"
            />
            <a :href="accountLink" class="menu-link">{{ accountText }}</a>
          </div>
        </div>
      </section>

      <!-- Points with bubbles & illustrations -->
      <section class="bubble-points" id="bubble-points">
        <h2 class="section-title">
          {{ $i18n.t('home.bubble-points-section-title') }}
        </h2>

        <article class="bubble-point bubble-point-kid">
          <div class="bubble-point__wrapper">
            <blockquote class="bubble-point__main">
              <q>{{ $i18n.t('home.bubble-points-quoted-1') }}</q>
            </blockquote>
            <p class="bubble-point__secondary">
              {{ $i18n.t('home.bubble-points-quoted-1-desc') }}
            </p>
          </div>
        </article>

        <article class="bubble-point bubble-point-mum">
          <div class="bubble-point__wrapper">
            <blockquote class="bubble-point__main">
              <q>{{ $i18n.t('home.bubble-points-quoted-2') }}</q>
            </blockquote>
            <p class="bubble-point__secondary">
              {{ $i18n.t('home.bubble-points-quoted-2-desc') }}
            </p>
          </div>
        </article>

        <article class="bubble-point bubble-point-lgbt">
          <div class="bubble-point__wrapper">
            <blockquote class="bubble-point__main">
              <q>{{ $i18n.t('home.bubble-points-quoted-3') }}</q>
            </blockquote>
            <p class="bubble-point__secondary">
              {{ $i18n.t('home.bubble-points-quoted-3-desc') }}
              <br />
              <strong>{{
                $i18n.t('home.bubble-points-quoted-3-addon')
              }}</strong>
            </p>
          </div>
        </article>

        <p class="bubble-point__callout-wrapper">
          <a
            href="#stowy-plans"
            class="btn btn-primary btn-L bubble-point__callout-btn"
          >
            <span>{{ $i18n.t('global.support-us') }}</span>
          </a>
        </p>
      </section>

      <!-- 3 blocks with long scrolling visual -->
      <section class="how-why-who">
        <div class="section-wrapper">
          <div class="how">
            <header class="how__head">
              <h2 class="section-title is-purple">
                {{ $i18n.t('home.how-why-1') }}
              </h2>
              <a href="#stowy-plans" class="btn-noBgd how__callout-btn">{{
                $i18n.t('global.im-interested')
              }}</a>
            </header>

            <div id="how__tabs">
              <ul class="how__tabs-nav">
                <li :class="{ 'is-active': activeHowStep === 0 }">
                  <a href="#" @click.prevent="activeHowStep = 0">
                    <span class="how__tabs-nav-number">1</span>
                    <span class="how__tabs-nav-text">{{
                      $i18n.t('home.how-why-2')
                    }}</span>
                  </a>
                </li>

                <li :class="{ 'is-active': activeHowStep === 1 }">
                  <a href="#" @click.prevent="activeHowStep = 1">
                    <span class="how__tabs-nav-number">2</span>
                    <span class="how__tabs-nav-text">{{
                      $i18n.t('home.how-why-3')
                    }}</span>
                  </a>
                </li>

                <li :class="{ 'is-active': activeHowStep === 2 }">
                  <a href="#" @click.prevent="activeHowStep = 2">
                    <span class="how__tabs-nav-number">3</span>
                    <span class="how__tabs-nav-text">{{
                      $i18n.t('home.how-why-4')
                    }}</span>
                  </a>
                </li>

                <li :class="{ 'is-active': activeHowStep === 3 }">
                  <a href="#" @click.prevent="activeHowStep = 3">
                    <span class="how__tabs-nav-number">4</span>
                    <span class="how__tabs-nav-text">{{
                      $i18n.t('home.how-why-5')
                    }}</span>
                  </a>
                </li>
              </ul>

              <div id="tabs-1" class="how__tab how__tab-1" v-show="activeHowStep === 0">
                <img
                  class="how-tab__visual"
                  src="@website-assets/img/how__visual-1@2x.jpg"
                  alt
                />
              </div>

              <div id="tabs-2" class="how__tab how__tab-2" v-show="activeHowStep === 1">
                <img
                  class="how-tab__visual"
                  src="@website-assets/img/how__visual-2@2x.jpg"
                  alt
                />
              </div>

              <div id="tabs-3" class="how__tab how__tab-3" v-show="activeHowStep === 2">
                <img
                  class="how-tab__visual"
                  src="@website-assets/img/how__visual-3@2x.jpg"
                  alt
                />
              </div>

              <div id="tabs-4" class="how__tab how__tab-4" v-show="activeHowStep === 3">
                <img
                  class="how-tab__visual"
                  src="@website-assets/img/how__visual-4@2x.jpg"
                  alt
                />
              </div>

              <div class="clear"></div>
            </div>

            <p class="how__callout-btn--mobile">
              <a href="#" class="btn-noBgd">{{
                $i18n.t('global.im-interested')
              }}</a>
            </p>
          </div>

          <div class="why">
            <h2 class="section-title section-title--center is-orange">
              {{ $i18n.t('home.why-trust') }}
            </h2>

            <ul class="why__list">
              <li class="why__point">
                <div class="rounded-image">
                  <img
                    src="@website-assets/img/pedagogique.png"
                    alt="Lettres pédagogiques"
                  />
                </div>
                <h4>{{ $i18n.t('home.why-testimonial-1-name') }}</h4>
                <p>{{ $i18n.t('home.why-testimonial-1-text') }}</p>
              </li>

              <li class="why__point">
                <div class="rounded-image">
                  <img src="@website-assets/img/familles.png" alt="Famille" />
                </div>
                <h4>{{ $i18n.t('home.why-testimonial-2-name') }}</h4>
                <p>{{ $i18n.t('home.why-testimonial-2-text') }}</p>
              </li>

              <li class="why__point">
                <div class="rounded-image">
                  <img
                    src="@website-assets/img/madeinfrance.png"
                    alt="Made in France"
                  />
                </div>
                <h4>{{ $i18n.t('home.why-testimonial-3-name') }}</h4>
                <p>{{ $i18n.t('home.why-testimonial-3-text') }}</p>
              </li>
            </ul>

            <p class="why__callout-wrapper">
              <a href="#stowy-plans" class="btn-noBgd why__callout-btn">{{
                $i18n.t('global.im-with-you')
              }}</a>
            </p>
          </div>
        </div>
      </section>

      <!-- Different plans to subscribe -->
      <section class="plans" id="stowy-plans">
        <div class="section-wrapper">
          <header class="plans__header">
            <div class="subtitle">
              <h3>
                {{ $i18n.t('home.roadmap-2') }}
                <strong>{{ $i18n.t('home.roadmap-3') }}</strong>
                {{ $i18n.t('home.roadmap-4') }}
              </h3>
            </div>
            <div></div>
          </header>

          <div class="plans__list">
            <!-- Free Plan -->
            <article
              id="plan-beta-tester"
              class="plan plan-purple"
              v-on:click="onSelect(0)"
            >
              <div class="plan__wrapper">
                <div class="plan__price">{{ $i18n.t('home.plan-free-1') }}</div>
                <div class="plan__price-wrapper">
                  <h3 class="plan__title">{{ $i18n.t('home.plan-free-5') }}</h3>
                </div>
                <ul class="plan__offer">
                  <li>{{ $i18n.t('home.plan-free-2') }}</li>
                  <li class="not-included">
                    {{ $i18n.t('home.plan-free-3') }}
                  </li>
                  <li class="not-included">
                    {{ $i18n.t('home.plan-free-4') }}
                  </li>
                </ul>
                <footer class="choose-plan-btn">
                  <a
                    :href="planHref('free')"
                    class="btn btn-secondary btn-L"
                  >
                    <span>{{ $i18n.t('global.choose-formula') }}</span>
                  </a>
                </footer>
              </div>
            </article>

            <!-- Plan Solo -->
            <article
              id="plan-solo"
              class="plan plan-blue"
              v-on:click="onSelect(1)"
            >
              <div class="plan__wrapper">
                <div class="plan__price">{{ $i18n.t('home.plan-solo-1') }}</div>
                <div class="plan__price-wrapper">
                  <h3 class="plan__title">{{ $i18n.t('home.plan-solo-5') }}</h3>
                  <div class="plan__price-info">
                    {{ $i18n.t('home.plan-solo-6') }}
                  </div>
                  <div class="plan__price-info">
                    {{ $i18n.t('home.billedMensually') }}
                  </div>
                </div>
                <ul class="plan__offer">
                  <li>{{ $i18n.t('home.plan-solo-2') }}</li>
                  <li>{{ $i18n.t('home.plan-solo-3') }}</li>
                  <li class="not-included">
                    {{ $i18n.t('home.plan-solo-4') }}
                  </li>
                </ul>
                <footer class="choose-plan-btn">
                  <a
                    :href="planHref('solo')"
                    class="btn btn-primary btn-L"
                  >
                    <span>{{ $i18n.t('global.choose-formula') }}</span>
                  </a>
                </footer>
              </div>
            </article>

            <!-- Multi kids -->
            <article
              id="plan-family"
              class="plan plan-orange"
              v-on:click="onSelect(2)"
            >
              <div class="plan__wrapper">
                <div class="plan__price">
                  {{ $i18n.t('home.plan-family-1') }}
                </div>
                <div class="plan__price-wrapper">
                  <h3 class="plan__title">
                    {{ $i18n.t('home.plan-family-5') }}
                  </h3>
                  <div class="plan__price-info">
                    {{ $i18n.t('home.plan-solo-6') }}
                  </div>
                  <div class="plan__price-info">
                    {{ $i18n.t('home.billedMensually') }}
                  </div>
                </div>
                <ul class="plan__offer">
                  <li>{{ $i18n.t('home.plan-family-2') }}</li>
                  <li>{{ $i18n.t('home.plan-family-3') }}</li>
                  <li>{{ $i18n.t('home.plan-family-4') }}</li>
                </ul>
                <footer class="choose-plan-btn">
                  <a
                    :href="planHref('multi')"
                    class="btn btn-secondary-orange btn-L"
                  >
                    <span>{{ $i18n.t('global.choose-formula') }}</span>
                  </a>
                </footer>
              </div>
            </article>
          </div>
          <div style="height: 26px" class="error-message">
            {{ userSession.error || '' }}
          </div>
        </div>
      </section>

      <footer class="stowy-footer">
        <div class="section-wrapper">
          <ul class="footer__left">
            <li>
              <router-link :to="{ name: 'Legals' }" target="_blank">{{
                $i18n.t('global.legals-term')
              }}</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Cgu' }" target="_blank">{{
                $i18n.t('global.cgv-cgu-term')
              }}</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Confidentiality' }" target="_blank">{{
                $i18n.t('global.confidentiality-term')
              }}</router-link>
            </li>
            <li>
              <a href="mailto:kevin@stowy.fr">{{
                $i18n.t('home.contact-address')
              }}</a>
            </li>
          </ul>

          <div class="footer__center">
            <img
              class="footer__logo"
              src="@website-assets/img/logo-stowy.png"
              alt="Stowy"
            />
            <p class="footer__social">
              <a
                href="https://www.facebook.com/StowyFR"
                target="_blank"
                class="footer__social-btn footer__facebook"
              ></a>

              <a
                href="https://www.twitter.com/StowyFR"
                target="_blank"
                class="footer__social-btn footer__twitter"
              ></a>
              <a
                href="https://www.instagram.com/StowyFR"
                target="_blank"
                class="footer__social-btn footer__insta"
              ></a>
            </p>
          </div>

          <p class="footer__copyright">
            {{ $i18n.t('home.copyright-title') }}
            <br />
            {{ $i18n.t('home.copyright-1') }}
            <br />
            {{ $i18n.t('home.copyright-2') }}
          </p>
        </div>
      </footer>

      <!-- 
        Classe à ajouter sur la classe .cookies: 
        - Pour afficher le mode "Configurer": .is-expanded
        - Une fois que les cookies sont validés: .is-accepted
      -->
      <div id="cookies" class="cookies" v-show="!userSession.cookies.acted">
        <div class="cookies__wrapper">
          <h3 class="cookies__title">{{ $i18n.t('home.cookies-title') }}</h3>
          <p class="cookies__intro">{{ $i18n.t('home.cookies-intro') }}</p>

          <div class="cookies--short" v-if="!isExpanded">
            <ul v-if="false" class="cookies-short__options">
              <li>
                <input
                  type="checkbox"
                  checked
                  disabled
                  v-model="userSession.cookies.essentials"
                />
                <label>{{ $i18n.t('home.cookies-option-1') }}</label>
              </li>
              <li>
                <input
                  type="checkbox"
                  checked
                  v-model="userSession.cookies.analytics"
                />
                <label>{{ $i18n.t('home.cookies-option-2') }}</label>
              </li>
              <li>
                <input
                  type="checkbox"
                  checked
                  v-model="userSession.cookies.ads"
                />
                <label>{{ $i18n.t('home.cookies-option-3') }}</label>
              </li>
            </ul>

            <div class="cookies__call-btns">
              <a class="btn btn-secondary" v-on:click="onExpandCookies()">
                <span>{{ $i18n.t('home.cookies-button-configure') }}</span>
              </a>
              <a
                class="btn btn-secondary"
                v-on:click="onSaveCookies(true, false, false)"
              >
                <span>{{ $i18n.t('home.cookies-button-refuse') }}</span>
              </a>
              <a
                class="btn btn-primary"
                v-on:click="onSaveCookies(true, true, true)"
              >
                <span>{{ $i18n.t('home.cookies-button-accept') }}</span>
              </a>
            </div>
          </div>

          <div class="cookies--long" v-show="isExpanded">
            <!-- Section des cookies Essentiels -->
            <div class="cookie-section">
              <div class="cookie-option">
                <input
                  class="cookies--long-checkbox"
                  type="checkbox"
                  id="essential"
                  checked
                  disabled
                  v-model="userSession.cookies.essentials"
                />
                <label for="essential">
                  <h4>{{ $i18n.t('home.cookies-option-1') }}</h4>
                </label>
              </div>
              <ul class="cookie-list">
                <li>{{ $i18n.t('home.cookies.essential.description') }}</li>
                <li>
                  <strong
                    >{{
                      $i18n.t('home.cookies.essential.list.session.name')
                    }}:</strong
                  >
                  {{
                    $i18n.t('home.cookies.essential.list.session.description')
                  }}. <br />
                  {{ $i18n.t('home.cookies.essential.list.session.data') }}
                  <br />
                  {{ $i18n.t('home.cookies.essential.list.session.duration') }}
                </li>
                <li>
                  <strong
                    >{{
                      $i18n.t('home.cookies.essential.list.consent.name')
                    }}:</strong
                  >
                  {{
                    $i18n.t('home.cookies.essential.list.consent.description')
                  }}. <br />
                  {{ $i18n.t('home.cookies.essential.list.consent.data') }}
                  <br />
                  {{ $i18n.t('home.cookies.essential.list.consent.duration') }}
                </li>
                <li>
                  <strong
                    >{{
                      $i18n.t('home.cookies.essential.list.app.name')
                    }}:</strong
                  >
                  {{ $i18n.t('home.cookies.essential.list.app.description') }}.
                  <br />
                  {{ $i18n.t('home.cookies.essential.list.app.data') }} <br />
                  {{ $i18n.t('home.cookies.essential.list.app.duration') }}
                </li>
              </ul>
            </div>

            <!-- Section des cookies Analytiques -->
            <div class="cookie-section">
              <div class="cookie-option">
                <input
                  class="cookies--long-checkbox"
                  type="checkbox"
                  id="analytics"
                  checked
                  v-model="userSession.cookies.analytics"
                />
                <label for="analytics">
                  <h4>{{ $i18n.t('home.cookies-option-2') }}</h4>
                </label>
              </div>
              <ul class="cookie-list">
                <li>{{ $i18n.t('home.cookies.analytics.description') }}</li>
                <li>
                  <strong
                    >{{
                      $i18n.t('home.cookies.analytics.list._ga.name')
                    }}:</strong
                  >
                  {{ $i18n.t('home.cookies.analytics.list._ga.description') }}.
                  <br />
                  {{ $i18n.t('home.cookies.analytics.list._ga.data') }} <br />
                  {{ $i18n.t('home.cookies.analytics.list._ga.duration') }}
                </li>
                <li>
                  <strong
                    >{{
                      $i18n.t('home.cookies.analytics.list._gid.name')
                    }}:</strong
                  >
                  {{ $i18n.t('home.cookies.analytics.list._gid.description') }}.
                  <br />
                  {{ $i18n.t('home.cookies.analytics.list._gid.data') }} <br />
                  {{ $i18n.t('home.cookies.analytics.list._gid.duration') }}
                </li>
                <li>
                  <strong
                    >{{
                      $i18n.t('home.cookies.analytics.list._gat.name')
                    }}:</strong
                  >
                  {{ $i18n.t('home.cookies.analytics.list._gat.description') }}.
                  <br />
                  {{ $i18n.t('home.cookies.analytics.list._gat.data') }} <br />
                  {{ $i18n.t('home.cookies.analytics.list._gat.duration') }}
                </li>
              </ul>
            </div>

            <!-- Section des cookies Publicitaires -->
            <div class="cookie-section">
              <div class="cookie-option">
                <input
                  class="cookies--long-checkbox"
                  type="checkbox"
                  id="ads"
                  v-model="userSession.cookies.ads"
                />
                <label for="ads">
                  <h4>{{ $i18n.t('home.cookies-option-3') }}</h4>
                </label>
              </div>
              <ul class="cookie-list">
                <li>{{ $i18n.t('home.cookies.advertising.description') }}</li>
                <li>
                  <strong
                    >{{
                      $i18n.t('home.cookies.advertising.list._gcl_au.name')
                    }}:</strong
                  >
                  {{
                    $i18n.t(
                      'home.cookies.advertising.list._gcl_au.description'
                    )
                  }}. <br />
                  {{ $i18n.t('home.cookies.advertising.list._gcl_au.data') }}
                  <br />
                  {{
                    $i18n.t('home.cookies.advertising.list._gcl_au.duration')
                  }}
                </li>
              </ul>
            </div>
            <div class="cookies__call-btns">
              <a
                class="btn btn-secondary"
                v-on:click="onSaveCookies(true, true, true)"
              >
                <span>{{ $i18n.t('home.cookies-button-accept-all') }}</span>
              </a>
              <a
                class="btn btn-primary"
                v-on:click="
                  onSaveCookies(
                    userSession.cookies.essentials,
                    userSession.cookies.analytics,
                    userSession.cookies.ads
                  )
                "
              >
                <span>{{
                  $i18n.t('home.cookies-button-accept-selection')
                }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="userSession.cookies.acted"
      class="cookie-trigger"
      @click="onResetCookies"
    >
      <span class="cookie-emoji">🍪</span>
    </div>

    <locale-switcher v-if="isDev" />
    <info-popup ref="infoPopup"></info-popup>
  </div>
</template>

<script>
  import InfoPopup from '../components_prelaunch/InfoPopup.vue'
  import LocaleSwitcher from '../components_prelaunch/LocaleSwitcher.vue'
  import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
  import Typed from '@common-components/Typed.vue'
  import { useHead } from '@unhead/vue'

  import { mapState } from 'vuex'

  export default {
    name: 'Home',
    components: {
      InfoPopup,
      LocaleSwitcher,
      VueCookieAcceptDecline,
      Typed,
    },

    setup() {
      useHead({
        title: 'Stowy - Histoires personnalisées pour enfants',
        meta: [
          // Meta Description
          {
            name: 'description',
            content:
              'Stowy propose des histoires personnalisées pour enfants, créez des souvenirs uniques en quelques clics.',
          },

          // Keywords for SEO
          {
            name: 'keywords',
            content:
              'histoires personnalisées, enfants, souvenirs, lecture, éducation, divertissement, Stowy',
          },

          // Open Graph (OG) Tags for social media sharing
          {
            property: 'og:title',
            content: 'Stowy - Histoires personnalisées pour enfants',
          },
          {
            property: 'og:description',
            content:
              'Créez des souvenirs uniques avec des histoires personnalisées pour vos enfants grâce à Stowy.',
          },
          {
            property: 'og:image',
            content: 'https://stowy.fr/assets/img/stowy-og-image.jpg',
          }, // Assurez-vous que cette image existe
          { property: 'og:url', content: 'https://stowy.fr' },
          { property: 'og:type', content: 'website' },
          { property: 'og:site_name', content: 'Stowy' },

          // Twitter Card Tags for social media sharing
          { name: 'twitter:card', content: 'summary_large_image' },
          {
            name: 'twitter:title',
            content: 'Stowy - Histoires personnalisées pour enfants',
          },
          {
            name: 'twitter:description',
            content:
              'Découvrez Stowy, l’application pour créer des histoires personnalisées pour enfants et partager des moments inoubliables.',
          },
          {
            name: 'twitter:image',
            content: 'https://stowy.fr/assets/img/stowy-twitter-card.jpg',
          }, // Assurez-vous que cette image existe
          { name: 'twitter:site', content: '@StowyFR' }, // Remplacez par votre compte Twitter si disponible

          // Author and Language Information
          { name: 'author', content: 'Stowy' },
          { name: 'language', content: 'fr' },

          // Robots Tag for SEO (index/noindex, follow/nofollow)
          { name: 'robots', content: 'index, follow' },

          // Viewport configuration for responsiveness
          { name: 'viewport', content: 'width=device-width, initial-scale=1' },

          // Charset
          { charset: 'utf-8' },
        ],
        link: [
          // Canonical URL for SEO
          { rel: 'canonical', href: 'https://stowy.fr' },
        ],
      })
    },

    data() {
      return {
        options: ['free', 'solo', 'family'],
        surname: [
          'surname-1',
          'surname-2',
          'surname-3',
          'surname-4',
          'surname-5',
          'surname-6',
          'surname-7',
          'surname-8',
        ],
        selectedOptionIndex: null,
        isCgvChecked: false,
        errors: [],
        isExpanded: false,
        deferredPrompt: null,
        canInstall: false,
        activeHowStep: 0,
      }
    },
    computed: {
      ...mapState(['userSession']),
      isAuthenticated() {
        const user = this.userSession?.auth?.record
        return !!(user && user.uid && !user.isAnonymous)
      },
      accountText() {
        return this.isAuthenticated ? 'Mon compte' : this.$i18n.t('global.connect')
      },
      accountLink() {
        return this.isAuthenticated ? '/account' : '/account/login'
      },
      typedOptions() {
        return {
          strings: this.surname.map((name) => this.$t('home.' + name)),
          typeSpeed: 100,
          deleteSpeed: 100,
          autoDelete: true,
          loop: true,
        }
      },
      isDev() {
        return process.env.NODE_ENV === 'development'
      },
      isEmailValid() {
        return (
          this.userSession.profile &&
          this.userSession.profile.email &&
          this.validateEmail(this.userSession.profile.email)
        )
      },
      isFirstNameValid() {
        return (
          this.userSession.profile &&
          this.userSession.profile.firstName &&
          this.validateName(this.userSession.profile.firstName)
        )
      },
      isLastNameValid() {
        return (
          this.userSession.profile &&
          this.userSession.profile.lastName &&
          this.validateName(this.userSession.profile.lastName)
        )
      },
      shouldEnableRegisterButton() {
        return !(
          this.userSession.auth.signingIn ||
          this.userSession.payment.awaiting ||
          this.userSession.payment.pending
        )
      },
      defaultSelectedOptionIndex() {
        // If user selected something manually, returns his selection first
        if (this.selectedOptionIndex != null) {
          return this.selectedOptionIndex
          // Returns user saved choice second
        } else if (
          this.userSession.profile &&
          this.userSession.profile.stripeRole
        ) {
          //Todo code a refaire avec un util ou classe
          return this.userSession.profile.stripeRole === 'free'
            ? 0
            : this.userSession.profile.stripeRole === 'solo'
              ? 1
              : 2
        }
        // Returns middle one by default
        return 1
      },
    },
    updated() {
      // Refresh selected option when state change
      this.onSelect(this.defaultSelectedOptionIndex)
    },
    mounted() {
      //Scroll
      window.addEventListener('scroll', this.handleScroll)

      //PWA
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault()
        console.debug('beforeinstallprompt fired')
        this.deferredPrompt = e
        this.canInstall = true
      })

      window.addEventListener('appinstalled', () => {
        console.debug('PWA a été installée')
        this.canInstall = false
        this.deferredPrompt = null
      })

      //Cookies
      this.userSession.cookies.essentials =
        JSON.parse(localStorage.getItem('cookies.essentials')) || true
      this.userSession.cookies.analytics =
        JSON.parse(localStorage.getItem('cookies.analytics')) || false
      this.userSession.cookies.ads =
        JSON.parse(localStorage.getItem('cookies.ads')) || false
      this.userSession.cookies.acted =
        JSON.parse(localStorage.getItem('cookies.acted')) || false

      if (this.userSession.cookies.acted) {
        this.isExpanded = false
      }

      if (
        this.userSession.cookies.acted &&
        (this.userSession.cookies.ads || this.userSession.cookies.analytics)
      ) {
        this.$store.dispatch('initializeAnalytics')
      }

      // Removed legacy jQuery UI tabs bootstrapping; using Vue state instead.
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      installApp() {
        if (this.deferredPrompt) {
          this.deferredPrompt.prompt() // Trigger installation modal
          this.deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('User accepted the A2HS prompt')
            } else {
              console.log('User dismissed the A2HS prompt')
            }
            this.deferredPrompt = null // Reset prompt
            this.canInstall = false
          })
        }
      },
      removeGoogleTagManager() {
        const gid = process.env.VUE_APP_FIREBASE_MEASUREMENT_ID

        // Vérifie si le script GTM est déjà présent
        const script = document.querySelector(
          `script[src*="googletagmanager.com/gtag/js?id=${gid}"]`
        )

        if (script) {
          // Supprime le script du document
          script.parentNode.removeChild(script)

          // Efface également le dataLayer si nécessaire
          if (window.dataLayer) {
            window.dataLayer = []
          }
        }
      },

      handleScroll() {
        const bubblePoints = document.querySelector('#bubble-points')
        const menu = document.querySelector('.menu')

        const bubbleTop =
          bubblePoints.getBoundingClientRect().top + window.scrollY

        const menuHeight = window.innerWidth < 768 ? '50px' : '75px'

        if (window.scrollY >= bubbleTop - 200) {
          menu.style.height = menuHeight
        } else {
          menu.style.height = '0'
        }
      },
      planHref(planKey) {
        return this.isAuthenticated ? '/account/plan' : `/account/register?plan=${planKey}`
      },
      validateName(inputText) {
        var format = /^[a-zA-Z]+/
        return inputText.match(format)
      },

      validateEmail(inputText) {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        return inputText.match(mailformat)
      },

      onSaveCookies(essentials, analytics, ads) {
        // Sauvegarde des choix de l'utilisateur dans le localStorage
        localStorage.setItem('cookies.essentials', JSON.stringify(essentials))
        localStorage.setItem('cookies.analytics', JSON.stringify(analytics))
        localStorage.setItem('cookies.ads', JSON.stringify(ads))
        localStorage.setItem('cookies.acted', JSON.stringify(true))

        // Mise à jour des préférences dans Vuex ou un autre système d'état
        this.userSession.cookies.essentials = essentials
        this.userSession.cookies.analytics = analytics
        this.userSession.cookies.ads = ads
        this.userSession.cookies.acted = true // mise à jour immédiate

        // Mise à jour des préférences dans la Consent API de Google
        if (ads || analytics) {
          this.$store.dispatch('initializeAnalytics')
        } else {
          this.$store.dispatch('removeAnalytics')
        }

        // Finaliser l'acceptation des cookies
        this.onCookiesAccepted()
      },
      onCookiesAccepted() {
        document.getElementById('cookies').classList.remove('is-expanded')
        document.getElementById('cookies').classList.add('is-accepted')
      },

      onExpandCookies() {
        this.isExpanded = true

        const cookieElement = document.getElementById('cookies')

        if (cookieElement) {
          cookieElement.classList.add('is-expanded')
        } else {
          console.warn("Element 'cookies' not found")
        }
      },
      onResetCookies() {
        // Réinitialise les cookies à leur état initial dans Vuex
        this.$store.commit('resetCookies')

        // Réinitialise les cookies dans localStorage
        localStorage.setItem('cookies.essentials', JSON.stringify(true))
        localStorage.setItem('cookies.analytics', JSON.stringify(false))
        localStorage.setItem('cookies.ads', JSON.stringify(false))
        localStorage.setItem('cookies.acted', JSON.stringify(false))

        // Met à jour les variables locales
        this.userSession.cookies.acted = false
        this.isExpanded = false // Assure que la popup s'affiche en mode non-expand

        document.getElementById('cookies').classList.remove('is-accepted')
      },

      onSelect(optionIndex) {
        try {
          this.selectedOptionIndex = optionIndex

          const freeClass = `plan plan-purple ${
            optionIndex === 0 ? 'is-active' : ''
          }`
          const soloClass = `plan plan-blue ${
            optionIndex === 1 ? 'is-active' : ''
          }`
          const familyClass = `plan plan-orange ${
            optionIndex === 2 ? 'is-active' : ''
          }`
          document.getElementById('plan-beta-tester').className = freeClass
          document.getElementById('plan-solo').className = soloClass
          document.getElementById('plan-family').className = familyClass
        } catch (error) {}
      },

      async proceed() {
        if (!this.isCgvChecked) {
          this.$store.dispatch('formError', this.$i18n.t('errors.cgv-check'))
        } else if (!this.shouldEnableRegisterButton) {
          return
        } else if (!this.isEmailValid) {
          this.$store.dispatch(
            'formError',
            this.$i18n.t('errors.invalid-email')
          )
        } else if (!this.isFirstNameValid) {
          this.$store.dispatch(
            'formError',
            this.$i18n.t('errors.invalid-firstname')
          )
        } else if (!this.isLastNameValid) {
          this.$store.dispatch(
            'formError',
            this.$i18n.t('errors.invalid-lastname')
          )
        } else {
          await this.$store.dispatch('formError', null)
          try {
            this.showRegisteringOngoing() // Enregistrement en cours

            const option = this.options[this.selectedOptionIndex]
            const signedUser = await this.$store.dispatch('SignUp', {
              email: this.userSession.profile.email,
              firstName: this.userSession.profile.firstName,
              lastName: this.userSession.profile.lastName,
              option: option,
            })

            if (option !== 'free') {
              this.showCheckoutOngoing() // Communication avec prestataire
            }

            const url = await this.$store.dispatch('checkout', {
              user: signedUser,
              option: option,
            })

            if (url && url.length) {
              // Paid plan
              this.showCheckoutPending(async () => {
                // Lien de paiement personnel securisé
                window.open(url, '_blank')

                this.showCheckoutOngoing() // Communication avec prestataire

                await this.$store.dispatch('paymentWaiting', {
                  user: signedUser,
                  url: url,
                })

                this.showRegisteringDone() // Merci !
              })
            } else {
              // Free plan
              this.showRegisteringDone() // Merci !
            }
          } catch (error) {
            this.showErrorMessage(error)
            await this.$store.dispatch('formError', error)
          }
        }
      },

      // Success with buttons
      async showRegisteringDone() {
        const p = await this.$refs.infoPopup.show({
          style: 'success',
          showAnimation: true,
          animated: true,
          message: this.$i18n.t('home.registering-done'),
          button: this.$i18n.t('global.close'),
          isButtonEnabled: true,
        })
      },

      // Loading with no buttons
      async showRegisteringOngoing() {
        const p = await this.$refs.infoPopup.show({
          message: this.$i18n.t('home.registering-ongoing'),
          style: 'loading',
          showAnimation: true,
          animated: true,
          button: this.$i18n.t('global.continue'),
          isButtonEnabled: false,
        })
      },

      // Info with enabled button and callback
      async showCheckoutPending(callback) {
        const p = await this.$refs.infoPopup.show({
          message: this.$i18n.t('home.checkout-pending'),
          style: 'info',
          showAnimation: true,
          animated: true,
          button: this.$i18n.t('global.continue'),
          buttonCallback: callback,
          isButtonEnabled: true,
        })
      },

      // Loading with disabled button
      async showCheckoutOngoing(callback) {
        const p = await this.$refs.infoPopup.show({
          message: this.$i18n.t('home.checkout-ongoing'),
          style: 'loading',
          showAnimation: true,
          animated: true,
          button: this.$i18n.t('global.continue'),
          isButtonEnabled: false,
        })
      },

      // Error with enabled button
      async showErrorMessage(message) {
        const p = await this.$refs.infoPopup.show({
          message: message,
          style: 'error',
          showAnimation: true,
          animated: false,
          button: this.$i18n.t('global.close'),
          isButtonEnabled: true,
        })
      },
    },
  }
</script>
